import { SVGProps } from 'react';

const ExclamationScaleSmallShapeTriangle = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8 5.99999V8.66666M8 11.3333H8.0075M6.86 2.57332L1.21333 12C1.09691 12.2016 1.03531 12.4302 1.03466 12.663C1.03401 12.8958 1.09433 13.1247 1.20962 13.327C1.32491 13.5293 1.49115 13.6978 1.69181 13.8159C1.89246 13.934 2.12053 13.9974 2.35333 14H13.6467C13.8795 13.9974 14.1075 13.934 14.3082 13.8159C14.5088 13.6978 14.6751 13.5293 14.7904 13.327C14.9057 13.1247 14.966 12.8958 14.9653 12.663C14.9647 12.4302 14.9031 12.2016 14.7867 12L9.14 2.57332C9.02115 2.37739 8.85381 2.2154 8.65413 2.10297C8.45445 1.99055 8.22916 1.93149 8 1.93149C7.77084 1.93149 7.54555 1.99055 7.34587 2.10297C7.14619 2.2154 6.97885 2.37739 6.86 2.57332Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ExclamationScaleSmallShapeTriangle;
